import React from 'react'
import {
    Box,
    VStack,
    Text,
    useMultiStyleConfig,
    Link as ChakraLink,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouterLink} from 'react-router-dom'
import {GoBackIcon} from '../../../components/icons'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import SanitizedHtml from '../../../components/html-sanitizer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

//utils
import routingObject from '../../../utils/static-routes'
// Helper to strip potential HTML from provided goBackText for aria-label
function stripHtml(html) {
    if (!html || typeof html !== 'string') return ''
    return html.replace(/<[^>]*>/g, '').trim()
}

export default function GoBackButton({
    goBackText = 'default',
    goBackToPath = routingObject.FAQ_PATH,
}) {
    const styles = useMultiStyleConfig('Faq', {})
    const {locale} = useMultiSite()
    const localizedGoBackToPath = `/${locale?.alias || locale?.id}${goBackToPath}`
    const {goBackButtonStyles} = styles || null
    const intl = useIntl()
    let defaultMessage = (
        <FormattedMessage
            id="faq_page.go_back_button.go_to_categories_message"
            defaultMessage="Categories"
        />
    )

    let specialCase = (
        <SanitizedHtml
            as={Text}
            html={goBackText}
            {...goBackButtonStyles?.goBackText}
            sanitize={true}
        />
    )
    let defaultCase = <Text {...goBackButtonStyles?.goBackText}>{defaultMessage}</Text>

    // ARIA label (intl) for screen readers
    const stripped = stripHtml(goBackText)
    const categoryName = goBackText === 'default' ? '' : stripped
    const ariaLabel =
        goBackText === 'default'
            ? intl.formatMessage({
                  id: 'faq_page.back.button.default.aria_label',
                  defaultMessage: 'Go back to FAQ categories',
              })
            : intl.formatMessage(
                  {
                      id: 'faq_page.back.button.category.aria_label',
                      defaultMessage: 'Go back to {category}',
                  },
                  {category: categoryName},
              )

    return (
        <VStack {...goBackButtonStyles?.outerContainer}>
            <ChakraLink
                as={RouterLink}
                to={localizedGoBackToPath}
                {...goBackButtonStyles?.buttonWrapper}
                aria-label={ariaLabel}
            >
                <Box {...goBackButtonStyles?.iconWrapper} aria-hidden="true">
                    <GoBackIcon flexShrink="0" data-testid="goBackIcon" />
                </Box>
                {goBackText === 'default' ? defaultCase : specialCase}
            </ChakraLink>
        </VStack>
    )
}

GoBackButton.propTypes = {
    goBackText: PropTypes.string,
    goBackToPath: PropTypes.string,
}
